import { render, staticRenderFns } from "./AdminEmailTemplateList.vue?vue&type=template&id=ae77bc44"
import script from "./AdminEmailTemplateList.vue?vue&type=script&lang=js"
export * from "./AdminEmailTemplateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports